module.exports = __webpack_public_path__ + "img/dressed-woman-3.d9ac5dc0.jpg";